// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2B0A1","name":"Header_name__4pHrV","birthday":"Header_birthday__2m9wn","skeleton":"Header_skeleton__11_r3"};